import PaymentModal from './PaymentModal.vue';
import PaymentMobileModal from './PaymentMobileModal.vue';
import { createModal } from '@lingtu/components';
import { getIsMobileUa } from '@lingtu/tools';

export function openPaymentModal(params = {}) {
  return createModal({
    params,
    component: getIsMobileUa() ? PaymentMobileModal : PaymentModal,
  });
}
